import {
    ISpringResponseBody, IOrderPostResponse, IPaymentStatusResponse,
    IPaymentDataPostResponse, PaymentStatusCode
} from '@app/shared/interfaces/response-interfaces';
import { fakeAuth } from '@app/core/auth/auth.values';
import { timeoutInMinutes } from '@app/shared/helpers/date-helper';
import { signingHistoryDataMock, orderHistoryMock } from '@app/certificates/history/history-mock';

export const ServerError: ISpringResponseBody = {
    code: 'SERVER_ERROR',
    status: 500,
    message: 'Възникна грешка, моля опитайте отново или се свържете с отдел "Поддръжка"',
    field: ''
};

export const SessionEnded: ISpringResponseBody = {
    code: 'SESSION_ENDED',
    status: 401,
    message: 'Сесията е изтекла, моля влезте отново',
    field: ''
};

export const LoginIdResponse = {
    OK: { code: 'OK', status: 200, message: 'Заявката за вход е регистрирана. Очаква се потвърждение от мобилното приложение' },
    NO_SUCH_ID: { code: 'NO_SUCH_ID', status: 403, message: 'Не е намерен такъв потребител' },
    FORBIDDEN: {
        code: 'FORBIDDEN',
        status: 403,
        message: 'Отказан достъп'
    },
    // MULTIPLE_IDENTIFIERS: { code: 'MULTIPLE_IDENTIFIERS', status: 409, message: 'Моля, уточнете вида на идентификатора (ЕГН или ЛНЧ)' },     TODO: Remove after some time if there are no problems
    OTHER_ERROR: ServerError
};

export const SignFileResponse = {
    OK: { code: 'OK', status: 200, message: 'Файлът е подаден за подписване' },
    CANCELLED_BY_THE_APP: { code: 'CANCELLED_BY_THE_APP', status: 403, message: 'Заявката за подпис е отказана от приложението' },
    TIMESTAMP_ERR: { code: 'TIMESTAMP_ERR', status: 503, message: 'Моля, използвайте ниво на подписване BASELINE_B' },
    SESSION_ENDED: SessionEnded,
    TIMEOUT: { code: 'TIMEOUT', status: 403, message: 'Времето за изпълнение на заявката беше просорчено' },
    OTHER_ERROR: ServerError
};

export const RevokeCertResponse = {
    OK: { code: 'OK', status: 200, message: 'Удостоверението е деактивирано' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const RestoreCertResponse = {
    OK: { code: 'OK', status: 200, message: 'Удостоверението е активирано' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const HoldCertResponse = {
    OK: { code: 'OK', status: 200, message: 'Удостоверението е временно прекратено' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const AddDeviceResponsePost = {
    OK: {
        code: 'OK', status: 200, message: 'Успешна заявка за QR',
        data: {
            qrString: 'Qasdf6541asfasdawer6551asdfcvsfser5qwr;opjgb'
        }
    },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const AddDeviceResponseGet = {
    OK: { code: 'OK', status: 200, message: 'Устройство е добавено' },
    WAITING_FOR_CONFIRMATION: { code: 'WAITING_FOR_CONFIRMATION', status: 202, message: 'Очаква потвърждение от мобилното приложение' },
    CANCELLED_BY_THE_APP: {
        code: 'CANCELLED_BY_THE_APP',
        status: 403,
        message: 'Заявката за добавяне на устройство е отказана от приложението'
    },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const ТransferCertResponse = {
    OK: { code: 'OK', status: 200, message: 'Удостоверението беше прехвърлено на новото устройство' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const LoginCheckResponse = {
    OK: {
        code: 'OK', status: 200, message: 'Успешен вход в системата',
        data: fakeAuth
    },
    WAITING_FOR_CONFIRMATION: { code: 'WAITING_FOR_CONFIRMATION', status: 202, message: 'Очаква потвърждение от мобилното приложение' },
    CANCELLED_BY_THE_APP: { code: 'CANCELLED_BY_THE_APP', status: 403, message: 'Заявката за вход е отказана от приложението' },
    USER_NOT_REGISTERED: { code: 'USER_NOT_REGISTERED', status: 200, message: 'Потребителят не е регистриран в системата' },
    OTHER_ERROR: ServerError
};

export const EmailSend = {
    EMAIL_SENT: { code: 'OK', status: 200, message: 'Беше изпратен e-mail за потвърждаване на регистрацията' },
    EMAIL_NOT_SENT: { code: 'MAIL_NOT_SENT', status: 401, message: 'Неуспешно изпращане на е-мейл' },
    EMAIL_ALREADY_REGISTERED: { code: 'EMAIL_ALREADY_REGISTERED', status: 403, message: 'Е-мейлът вече е регистриран в системата' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const EmailVerification = {
    EMAIL_VERIFICATION_SUCCESSFUL: { code: 'OK', status: 200, message: 'Е-мейлът беше регистриран успешно' },
    INVALID_VERIFICATION_TOKEN: { code: 'INVALID_VERIFICATION_TOKEN', status: 406, message: 'Невалиден линк' },
    VERIFICATION_TOKEN_EXPIRED: { code: 'VERIFICATION_TOKEN_EXPIRED', status: 406, message: 'Валидността на линка е изтекла' },
    EMAIL_ALREADY_REGISTERED: { code: 'EMAIL_ALREADY_REGISTERED', status: 409, message: 'Е-мейлът вече е регистриран в системата' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const EmailCodeSend = {
    EMAIL_CODE_SENT: {
        code: 'OK', status: 200, message: 'Беше изпратен e-mail, съдържащ код за потвърждаване на регистрацията',
        data: { expTimestamp: timeoutInMinutes(1) }
    },
    EMAIL_NOT_SENT: { code: 'MAIL_NOT_SENT', status: 401, message: 'Неуспешно изпращане на е-мейл' },
    EMAIL_ALREADY_REGISTERED: { code: 'EMAIL_ALREADY_REGISTERED', status: 409, message: 'Е-мейлът вече е регистриран в системата' },
    REGISTRATION_NOT_FINISHED: {
        code: 'REGISTRATION_NOT_FINISHED',
        status: 208, message: 'Регистрацията не е завършена',
        data: { expTimestamp: timeoutInMinutes(2) }
    },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const EmailCodeVerification = {
    EMAIL_VERIFICATION_SUCCESSFUL: { code: 'OK', status: 200, message: 'Е-мейлът беше регистриран успешно' },
    INVALID_OTP_CODE: { code: 'INVALID_OTP_CODE', status: 406, message: 'Невалиден код' },
    EXPIRED_OTP_CODE: { code: 'EXPIRED_OTP_CODE', status: 406, message: 'Валидността на кода е изтекла' },
    EMAIL_ALREADY_REGISTERED: { code: 'EMAIL_ALREADY_REGISTERED', status: 409, message: 'Е-мейлът вече е регистриран в системата' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const SMSSend = {
    SMS_SENT: {
        code: 'OK', status: 200, message: 'Беше изпратено съобщение, съдържащо код за потвърждаване на регистрацията',
        data: { expTimestamp: timeoutInMinutes(3) }
    },
    PHONENUMBER_ALREADY_REGISTERED: {
        code: 'PHONENUMBER_ALREADY_REGISTERED', status: 409, message: 'Телефонният номер вече е регистриран в системата'
    },
    SMS_NOT_SENT: { code: 'SMS_NOT_SENT', status: 401, message: 'Неуспешно изпращане на SMS' },
    REGISTRATION_NOT_FINISHED: {
        code: 'REGISTRATION_NOT_FINISHED',
        status: 208, message: 'Регистрацията не е завършена',
        data: { expTimestamp: timeoutInMinutes(4) }
    },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError,
    MAX_PHONE_NUMBERS_THRESHOLD_ERROR: {
        code: 'MAX_PHONE_NUMBERS_THRESHOLD_ERROR',
        status: 429, message: 'Достигнат е максималният брой на регистрирани номера на Вашия профил. Моля, свържете с отдел "Поддръжка"',
        data: {}
    },
};

export const SMSVerification = {
    PHONENUMBER_VERIFICATION_SUCCESSFUL: { code: 'OK', status: 200, message: 'Вашият телефонен номер беше регистриран успешно' },
    PHONENUMBER_ALREADY_REGISTERED: {
        code: 'PHONENUMBER_ALREADY_REGISTERED', status: 409, message: 'Телефонният номер вече е регистриран в системата'
    },
    INVALID_OTP_CODE: { code: 'INVALID_OTP_CODE', status: 406, message: 'Невалиден код' },
    EXPIRED_OTP_CODE: { code: 'EXPIRED_OTP_CODE', status: 406, message: 'Валидността на кода е изтекла' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const EmergencyCodeSend = {
    ENTER_VERIFICATION_CODE: {
        code: 'ENTER_VERIFICATION_CODE',
        status: 200, message: 'Моля, въведете код за верификация',
        data: { expTimestamp: timeoutInMinutes(3) }
    },
    NO_LOGIN_ID_REGISTERED: {
        code: 'NO_LOGIN_ID_REGISTERED', status: 200, message:
            'Нямате регистриран идентификатор за вход в нашата система'
    },
    MESSAGE_SENT: { code: 'MESSAGE_SENT', status: 200, message: 'Беше изпратено съобщение, съдържащо код за вход в системата' },
    MESSAGE_NOT_SENT: { code: 'MESSAGE_NOT_SENT', status: 401, message: 'Неуспешно изпращане на съобщение' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const EmergencyCodeVerification = {
    EMERGENCY_CODE_VERIFICATION_SUCCESSFUL: { code: 'OK', status: 200, message: 'Успешна верификация на код за достъп' },
    INVALID_OTP_CODE: { code: 'INVALID_OTP_CODE', status: 406, message: 'Невалиден код' },
    EXPIRED_OTP_CODE: { code: 'EXPIRED_OTP_CODE', status: 406, message: 'Валидността на кода е изтекла' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const DeleteDeviceResponse = {
    OK: { code: 'OK', status: 200, message: 'Устройството беше изтрито!' },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const CertificateHistoryResponse = {
    OK: { code: 'OK', status: 200, message: 'OK', data: signingHistoryDataMock },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const OrderResponse = {
    OK: { code: 'OK', status: 200, message: 'OK', data: orderHistoryMock },
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const OrderPostResponseMock = {
    OK: { code: 'OK', status: 200, message: 'OK', data: orderHistoryMock[0] } as IOrderPostResponse,
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const GetPaymentStatusResponseMock = {
    OK: {
        code: 'OK', status: 200, message: 'Плащането е извършено успешно', data: PaymentStatusCode.FINISHED_SUCCESS
    } as IPaymentStatusResponse,
    WAITING: {
        code: 'WAITING', status: 200, message: 'Изчаква се потвърждение на плащането',
        data: PaymentStatusCode.WAITING_PAYMENT_IN_PROGRESS
    } as IPaymentStatusResponse,
    NOK: {
        code: 'NOK', status: 200, message: 'Плащането е неуспешно', data: PaymentStatusCode.FINISHED_REJECTED
    } as IPaymentStatusResponse,
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};

export const GetPaymentDataResponseMock = {
    OK: { code: 'OK', status: 200, message: 'OK', data: { paymentData: 'http://test.test' } } as IPaymentDataPostResponse,
    SESSION_ENDED: SessionEnded,
    OTHER_ERROR: ServerError
};
